export const EmitterEvents = Object.freeze({
  CTA_MODAL_OPEN: 'cta_modal_open',
});
